import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Pagination, Stack } from "@mui/material";
import moment from "moment";
import {
  Plus,
  Image,
  Video,
  FileText,
  Edit2,
  Trash2,
  Download,
  Calendar,
  X,
} from "lucide-react";

import { Addstocks } from "./addstocks";
import { EditStock } from "./adminStocksEdit";
import { Loader } from "./loader";
import api from "../../api";
import "./AllPostAdmin.css";

export function AllAdminStocks() {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfPost, setnoOfPost] = useState(0);
  const [loader, setLoader] = useState(true);

  const [show, setShow] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  const getPosts = async () => {
    try {
      setLoader(true);
      const res = await api.stocksGetAdmin({ page });
      setData(res.post);
      setnoOfPost(res.count);
      setLimit(res.limit);
      setLoader(false);
    } catch (err) {
      setLoader(false);
    }
  };

  const deletePost = async (id) => {
    if (!window.confirm("Are you sure you want to delete this trade?")) return;
    setLoader(true);
    await api.stocksDelete({ id });
    getPosts();
  };

  useEffect(() => {
    getPosts();
  }, [page]);

  const withImages = data.filter((d) => d.imageTitle).length;
  const withVideos = data.filter((d) => d.video).length;
  const withFiles = data.filter((d) => d.pdfFile).length;

  return (
    <div className="crypto-trades-admin">
      {/* ================= HEADER ================= */}
      <div className="crypto-trades-header">
        <div className="content-of-header">
          <div className="title-section">
            <h2 className="crypto-trades-title">
              <span className="crypto-trades-icon">📈</span>
              Stock & Commodities Trades
            </h2>
            <p className="crypto-trades-subtitle">
              Manage and monitor all stock trading posts ({noOfPost})
            </p>
          </div>

          <button
            className="crypto-trades-add-btn"
            onClick={() => setShow(true)}
          >
            <Plus size={16} /> Add Stocks
          </button>
        </div>

        {/* ================= STATS ================= */}
        <div className="crypto-trades-stats">
          <div className="col-lg-4">
            <div className="stat-card">
              <div className="stat-icon total-trades-icon">📊</div>
              <div className="stat-content">
                <div className="stat-number">{noOfPost}</div>
                <p className="stats-label">Total Trades</p>
              </div>
            </div>
          </div>

          {/* <div className="stat-card">
            <div className="stat-icon image-trades-icon">
              <Image size={20} />
            </div>
            <div className="stat-content">
              <div className="stat-number">{withImages}</div>
              <p className="stats-label">With Images</p>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon video-trades-icon">
              <Video size={20} />
            </div>
            <div className="stat-content">
              <div className="stat-number">{withVideos}</div>
              <p className="stats-label">With Videos</p>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon file-trades-icon">
              <FileText size={20} />
            </div>
            <div className="stat-content">
              <div className="stat-number">{withFiles}</div>
              <p className="stats-label">With Files</p>
            </div>
          </div> */}
        </div>
      </div>

      {/* ================= TABLE ================= */}
      <div className="crypto-trades-table-container">
        <div className="table-card">
          <StockTable
            data={data}
            page={page}
            setPage={setPage}
            limit={limit}
            noOfPost={noOfPost}
            deletePost={deletePost}
            onEdit={(item) => {
              setSelectedData(item);
              setShowEdit(true);
            }}
            onAdd={() => setShow(true)}
          />
        </div>
      </div>

      {/* ADD MODAL */}
      <Modal show={show} size="xl" centered onHide={() => setShow(false)}>
        <Modal.Header className="modal-header-custom">
          <Modal.Title>Add New Stock Trade</Modal.Title>
          <button
            className="modal-close-btn"
            onClick={() => setShow(false)}
            aria-label="Close"
          >
            <X size={20} />
          </button>
        </Modal.Header>
        <Modal.Body className="modal-body-custom">
          <Addstocks getPosts={getPosts} setShow={setShow} />
        </Modal.Body>
      </Modal>

      {/* EDIT MODAL */}
      <Modal
        show={showEdit}
        size="lg"
        centered
        onHide={() => setShowEdit(false)}
      >
        <Modal.Header className="modal-header-custom">
          <Modal.Title>Edit Stock Trade</Modal.Title>
          <button
            className="modal-close-btn"
            onClick={() => setShowEdit(false)}
            aria-label="Close"
          >
            <X size={20} />
          </button>
        </Modal.Header>
        <Modal.Body className="modal-body-custom">
          <EditStock
            editData={selectedData}
            setShow={setShowEdit}
            getData={getPosts}
          />
        </Modal.Body>
      </Modal>

      {loader && <Loader />}
    </div>
  );
}

/* ================= TRADE CELL ================= */

const TradeCell = ({ item }) => {
  const { tradeType, stockTrade, forexTrade } = item;
  const trade = tradeType === "stock" ? stockTrade : tradeType === "forex" ? forexTrade : null;

  if (!tradeType || !trade) return <span style={{ color: "#aaa" }}>—</span>;

  const isStock = tradeType === "stock";
  const statusColor =
    trade.status === "Open" ? "#16a34a" :
    trade.status === "TP Hit" ? "#2563eb" :
    trade.status === "SL Hit" ? "#dc2626" : "#6b7280";

  return (
    <div style={{
      background: isStock ? "#f0fdf4" : "#eff6ff",
      border: `1px solid ${isStock ? "#bbf7d0" : "#bfdbfe"}`,
      borderRadius: 10,
      padding: "8px 12px",
      minWidth: 160,
      fontSize: 12,
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
        <span style={{
          background: isStock ? "#16a34a" : "#2563eb",
          color: "#fff",
          fontSize: 10,
          fontWeight: 700,
          padding: "2px 7px",
          borderRadius: 999,
          textTransform: "uppercase",
        }}>
          {tradeType}
        </span>
        <span style={{
          fontSize: 10,
          fontWeight: 700,
          color: statusColor,
          background: `${statusColor}18`,
          padding: "2px 7px",
          borderRadius: 999,
        }}>
          {trade.status || "Open"}
        </span>
      </div>
      <div style={{ fontWeight: 700, color: "#1e293b", marginBottom: 4 }}>
        {trade.currency || "—"}
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 2, color: "#475569" }}>
        {trade.positionType && (
          <span style={{ color: trade.positionType === "Long" ? "#16a34a" : "#dc2626", fontWeight: 700 }}>
            {trade.positionType === "Long" ? "▲ Long (BUY)" : "▼ Short (SELL)"}
          </span>
        )}
        {trade.entryPrice != null && (
          <span>Entry: <strong>${trade.entryPrice}</strong></span>
        )}
        {trade.takeProfit != null && (
          <span>TP: <strong>${trade.takeProfit}</strong></span>
        )}
        {trade.stopLoss != null && (
          <span>SL: <strong>${trade.stopLoss}</strong></span>
        )}
        {trade.pnlUSDT != null && (
          <span style={{ color: trade.pnlUSDT >= 0 ? "#16a34a" : "#dc2626" }}>
            PNL: <strong>{trade.pnlUSDT >= 0 ? "+" : ""}{trade.pnlUSDT} USDT</strong>
          </span>
        )}
      </div>
    </div>
  );
};

/* ================= TABLE ================= */

const StockTable = ({
  data,
  page,
  setPage,
  limit,
  noOfPost,
  deletePost,
  onEdit,
  onAdd,
}) => {
  const formatDate = (date) => moment(date).format("MMM D, YYYY • h:mm A");
  const [imgPopup, setImgPopup] = useState(null);

  return (
    <div className="table-responsive">
      <table className="crypto-trades-table">
        <thead>
          <tr>
            <th scope="col">IMAGE</th>
            <th scope="col">VIDEO</th>
            <th scope="col">FILE</th>
            <th scope="col">TRADE</th>
            <th scope="col">DESCRIPTION</th>
            <th scope="col">CREATED BY</th>
            <th scope="col">CREATED AT</th>
            <th scope="col" className="text-center">
              ACTIONS
            </th>
          </tr>
        </thead>

        <tbody>
          {data.length > 0 ? (
            data.map((item, idx) => (
              <tr key={idx} className="crypto-trade-row">
                <td>
                  {item.imageTitle ? (
                    <div className="media-preview">
                      {item.imageTitle.split(",").map((val, key) => {
                        const fmt = item.imageFormat.split(",")[key];
                        const src = `${process.env.REACT_APP_S3URL}/img_${val}.${fmt}`;
                        return (
                          <div
                            className="pImage"
                            key={key}
                            onClick={() => setImgPopup(src)}
                            style={{ cursor: "pointer" }}
                          >
                            <img src={src} alt={`Preview ${key + 1}`} />
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <span className="empty-cell">-</span>
                  )}
                </td>

                <td>{item.video ? <Video size={16} /> : "-"}</td>

                <td>
                  {item.pdfFile ? (
                    <a
                      className="file-link"
                      href={`${process.env.REACT_APP_S3URL}/${item.pdfFile}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="file-icon pdf-icon">
                        <FileText size={18} />
                      </span>
                      <span className="file-name">Download</span>
                    </a>
                  ) : (
                    "-"
                  )}
                </td>

                <td>
                  <TradeCell item={item} />
                </td>

                <td className="description-container">
                  <div
                    className="description-content"
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  />
                </td>

                <td>
                  <div className="creator-info">
                    <div className="creator-avatar">
                      {item?.createdBy?.email?.[0]?.toUpperCase()}
                    </div>
                    <div className="creator-details">
                      <span className="creator-email">
                        {item?.createdBy?.email}
                      </span>
                      <span className="creator-role">Admin</span>
                    </div>
                  </div>
                </td>

                <td>
                  <div className="date-info">
                    <div className="date-icon">
                      <Calendar size={16} />
                    </div>
                    <div className="date-details">
                      <span className="date-formatted">
                        {moment(item.createdAt).format("MMM D, YYYY")}
                      </span>
                      <span className="time-ago">
                        {moment(item.createdAt).fromNow()}
                      </span>
                    </div>
                  </div>
                </td>

                <td>
                  <div className="action-buttons">
                    <button
                      className="action-btn edit-btn"
                      onClick={() => onEdit(item)}
                    >
                      <Edit2 size={16} />
                    </button>

                    <button
                      className="action-btn delete-btn"
                      onClick={() => deletePost(item._id)}
                    >
                      <Trash2 size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" className="empty-table-message">
                <div className="empty-state">
                  <div className="empty-state-icon">📉</div>
                  <h3 className="empty-state-title">No Stock Posts Found</h3>
                  <p className="empty-state-description">
                    Start by adding your first stock trade
                  </p>
                  <button className="empty-state-btn" onClick={onAdd}>
                    + Add First Trade
                  </button>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Show pagination only when there's data */}
      {data.length > 0 && (
        <div className="pagination-container">
          <Pagination
            page={page}
            count={Math.ceil(noOfPost / limit)}
            onChange={(e, v) => setPage(v)}
          />
        </div>
      )}

      {/* IMAGE LIGHTBOX */}
      <Modal show={!!imgPopup} centered size="lg" onHide={() => setImgPopup(null)}>
        <Modal.Header className="modal-header-custom">
          <Modal.Title>Image Preview</Modal.Title>
          <button
            className="modal-close-btn"
            onClick={() => setImgPopup(null)}
            aria-label="Close"
          >
            <X size={20} />
          </button>
        </Modal.Header>
        <Modal.Body style={{ padding: 0, textAlign: "center", background: "#000" }}>
          <img
            src={imgPopup}
            alt="Full size preview"
            style={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain", display: "block", margin: "0 auto" }}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};
